import * as React from 'react';
import { connect } from 'react-redux';
import CalCalDataApi from '../../api/CalCalDataApi';
import SaForm from './saForm';
import { Container, Header, Content, Text, Icon, Spinner, View, Left, Right, Body, Button, Title, Toast, Footer, Separator } from 'native-base';
import { StyleSheet, KeyboardAvoidingView, BackHandler, Keyboard, LayoutAnimation } from 'react-native';
import diff from 'object-diff';
import * as _ from 'lodash';

import { SubmissionError, change } from 'redux-form';
import Alert from '../../components/alert';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
const { updateSyncErrors } = require('redux-form/lib/actions').default;
//This is a class. Hot reload reloads the closest class up from functional components and since this is on the nav, was reloading the whole nav!

//Load the form layout big object and present form itself. Take care of saving / updating, don't go back until happily saved!
class SaFormContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			taxyear: null,
			showFooter: true,
			reloadLayout: false
		};
	}

	componentDidMount() {
		this.backHandler = BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
		this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow.bind(this));
		this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide.bind(this));
	}

	componentWillUnmount() {
		this.backHandler.remove();
		this.keyboardDidShowListener.remove();
		this.keyboardDidHideListener.remove();
	}
	_keyboardDidShow() {
		//LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
		//this.setState({ showFooter: false });
	}

	_keyboardDidHide() {
		//LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
		//this.setState({ showFooter: true });
	}

	handleBackPress = () => {
		this.saveAndBack(); // works best when the goBack is async
		return true; //to cancel the backpress
	};

	async saveAndBack() {
		if (!this.refs || !this.refs.form) return this.props.navigation.goBack();
		let errors = await this.refs.form.submit();
		console.log('Errors: ', errors, errors ? 'e' : 'no');
		const badErrors = false;
		if (errors) {
			Object.keys(errors).forEach(v => {
				//if (v.form == this.props.route.params.form) {
				Toast.show({
					text: 'Error in box ' + v + ': ' + errors[v],
					position: 'top',
					type: 'danger',
					duration: 4000,
					textStyle: { textAlign: 'center' }
				});
				//	badErrors = true;
				//}
			});
			//if (!badErrors) this.props.navigation.goBack();
		} else {
			this.props.navigation.goBack();
		}
	}

	handleSubmit(values) {
		//let difference = diff(this.state.figs, values);
		/*let difference = _.difference(this.state.figs, values);
		if (Object.keys(difference).length == 0) {
			__DEV__ && console.log('no changes');

			return false;
		}*/
		//diff was excluding false values that had been added. Like EMP6 which was then never set
		__DEV__ && console.log('update', values);
		return CalCalDataApi.dataUpdate('sa/' + this.state.taxyear, values, this.props.jwt, res => {
			//console.log('handleSubmit ', res);
			if (res.success) {
				this.setState({ figs: values });
				return false;
			} else if (res.validationErrors) {
				console.log('validationErrors ', res.validationErrors);
				throw new SubmissionError(res.validationErrors);
			} else if (res.error) {
				//no specific validation errors so allow go back but present alert
				Alert.alert('Save error', res.message || res.error);
				throw new SubmissionError({});
			}
		});
		//const fakeError = { YPD3: 'Oh no' };
		//throw new SubmissionError(fakeError);
	}

	setHidden(field, hidden, wasTouched, animate) {
		var { layout } = this.state;
		//console.log(`setting field ${field} `, hidden ? 'hidden' : 'visible');
		const el = layout.boxes.find(element => element.name == field) || layout.boxes.reduce((accum, box) => accum || (box.items && box.items.find(element => element.name == field)), false);

		//going 2 deep, searches items of boxes (fieldsets)
		if (el) {
			if (el.doHide != hidden) {
				__DEV__ && console.log(hidden ? 'hide' : 'show', field, wasTouched ? 'touched' : 'no touched');
				if (wasTouched && !hidden && el.defaultVal) this.props.changeVal(el.name, el.defaultVal);
				if (wasTouched && !!hidden) this.props.changeVal(el.name, el.hideVal || '');
				animate && LayoutAnimation.configureNext(LayoutAnimation.Presets.linear);
				el.doHide = hidden;
				this.setState({ layout });
			}
		}
	}

	async reloadLayout() {
		let errors = await this.refs.form.submit();
		this.loadLayout();
	}

	loadLayout() {
		const { params } = this.props.route;
		const { y, form } = params;
		this.setState({
			loading: true,
			taxyear: y,
			reloadLayout: false
		});
		this.state.reloadLayout = false; //just in case!
		CalCalDataApi.dataLoad('sa/' + y + '/form/' + form, this.props.jwt, res => {
			if (!res.error) this.setState({ loading: false, layout: res });
		});
	}

	loadFigs(y, sets) {
		this.setState({
			loadingFigs: true
		});
		sets &&
			CalCalDataApi.dataLoad('sa/' + y + '/' + sets, this.props.jwt, res => {
				if (!res.error) this.setState({ loadingFigs: false, figs: res });
			});
	}

	render() {
		const { navigation, jwt, years, route } = this.props;
		const { params } = route;

		const { y, year, form, doCheck } = params;
		const { loading, layout, loadingFigs, figs, showFooter, reloadLayout } = this.state;

		if (!loading && !layout) {
			this.loadLayout();
		}

		if (doCheck)
			CalCalDataApi.dataLoad('sa/' + y + '/check', jwt, res => {
				//coming knowing something is wrong with this - check on load and highlight
				if (res && !res.success) this.props.dispatch(updateSyncErrors('sa', res.errors));
			});

		if (layout && !loadingFigs && !figs) {
			this.loadFigs(y, layout.sets);
		}

		//console.log('figs', figs, layout, this.refs);

		return (
			<Container>
				<Header>
					<Left style={{ flex: null }}>
						<Button transparent onPress={() => this.props.navigation.goBack()} style={{ width: 50, padding: 0 }}>
							<Icon active name="close" style={{ margin: 0 }} />
						</Button>
					</Left>
					<Body style={{ flex: 1, alignItems: 'center' }}>
						<Title>{layout ? layout.title : `Form ${form}`}</Title>
						<Text style={styles.headerTxt}>{year}</Text>
					</Body>
					<Right style={{ flex: null }}>
						<Button transparent onPress={() => this.saveAndBack()} style={{ width: 50, padding: 0 }}>
							<Icon active name="checkmark" style={{ margin: 0 }} />
						</Button>
					</Right>
				</Header>

				<Content>
					{!!layout && !loadingFigs ? (
						<>
							<SaForm
								layout={layout}
								figs={figs}
								formName={form}
								initialValues={figs}
								ref="form"
								onSubmit={this.handleSubmit.bind(this)}
								setHidden={this.setHidden.bind(this)}
								reloadLayout={this.reloadLayout.bind(this)}
								nav={navigation}
								setBox={this.props.changeVal}
							/>
							{false && (
								<Footer>
									<Button style={{ backgroundColor: '#8fbcd6', flex: 1 }} onPress={() => this.props.navigation.goBack()}>
										<Text style={{ flex: 1, color: '#295670', textAlign: 'center' }}>Cancel</Text>
									</Button>

									<Button style={{ backgroundColor: '#438eb9', androidRippleColor: '#FFF', flex: 1 }} onPress={() => this.saveAndBack()}>
										<Text style={{ flex: 1, textAlign: 'center' }} name="checkmark">
											Save
										</Text>
									</Button>
								</Footer>
							)}
						</>
					) : (
						<View>
							<ShimmerPlaceHolder autoRun width={300} style={{ margin: 2, height: 24 }} />
							<Separator />
							<ShimmerPlaceHolder autoRun width={200} style={{ margin: 2, height: 24 }} />
							<ShimmerPlaceHolder autoRun width={500} style={{ margin: 2, height: 24 }} />
						</View>
					)}
				</Content>
			</Container>
		);
	}
}

const styles = StyleSheet.create({
	headerTxt: {
		color: '#EEE'
	}
});

function bindAction(dispatch) {
	return {
		changeVal: (field, val) => dispatch(change('sa', field, val)),
		dispatch
	};
}

const mapStateToProps = state => ({
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	years: state.globalReducer.yrs
});
export default connect(mapStateToProps, bindAction)(SaFormContainer);
